export function dataInRequest(params = {}) {
  return {
    type: '@mensagemSistemaFrentista/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagemSistemaFrentista/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagemSistemaFrentista/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagemSistemaFrentista/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagemSistemaFrentista/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagemSistemaFrentista/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagemSistemaFrentista/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagemSistemaFrentista/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagemSistemaFrentista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagemSistemaFrentista/RECORD_FILTERING',
    payload: { params },
  };
}
